export enum COLORS {
  white = "rgb(255, 255, 255)",
  whiteTransparent = `rgba(255, 255, 255, 0.8 )`,

  black = "#000",
  purple = "#464bff",
  beige = "#fcf5f3",

  violet = "#f2dafd",
  violetLight = "#eeebf2",

  grayLight = "#736b7e",
  grayLighter = "#c4c4c4",
  grayDark = "#1f1f1f",

  green = "#2b6059",
  greenDark = "#0a6259",

  red = "#f96b6b",
  redLight = "rgb(251, 245, 243)",
  redLightTransparent = "rgba(252, 245, 243, 0.82 )",
  redDark = "#fd7064",

  blueLight = "#dae2fd",

  borderGray = "#e0d3cf",
  borderGrayLight = "#e2dfe6",
  borderGrayLighter = "#f0edf4",

  goodGreenBg = "#f3f1b5",
  goodGreenFg = "#8f9008",
  veryGoodGreenBg = "#dae2a5",
  excellentGreenBg = "#cad6b8",
  teal = "#ddf1ef",
  orange = "#ff8413",
}

export const COMMON_COLORS_PALETTE = [
  "#F94144",
  "#4D908E",
  "#F9C74F",
  "#277DA1",
  "#F8961E",
  "#90BE6D",
  "#F9844A",
  "#43AA8B",
  "#F3722C",
  "#577590",
];
